<template>
  <div style="text-align: left;">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/negocio-orcamentos' }">Orçamentos de Negócios</el-breadcrumb-item>
          <el-breadcrumb-item>Divisão</el-breadcrumb-item>
          <el-breadcrumb-item>Atividade</el-breadcrumb-item>
          <el-breadcrumb-item>Gerencial</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="10" style="text-align: center;">
      <el-col :span="24">
        <h1>Orçamento da Atividade da Divisão do Negócio (Gerencial)</h1>
      </el-col>
    </el-row>

    <el-row type="flex" justify="left" :gutter="10" style="">
      <el-col :span="24">
        <el-button type="primary" icon="el-icon-back" @click="$router.go(-1)">Voltar</el-button>
      </el-col>
    </el-row>

    <el-row type="flex" justify="left" :gutter="10" style="width: 100%;">
      <div style="height: auto;" class="details-content">
        <table>
          <tr>
            <td><h2>Detalhes da Revisão do Negócio:</h2></td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Obra:</strong> {{divisao.cliente.cliente_cod}} - {{divisao.cliente.nome_fantasia}}</td>
            <td><strong>Valor Revisão do Negócio:</strong> R$ {{formatarValor(divisao.negocio.total_mp, 2)}}</td>
          </tr>
          <tr>
            <td><strong>Cidade:</strong> {{divisao.cliente.municipio}} - {{divisao.cliente.uf}} - {{divisao.cliente.pais}}</td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Negócio:</strong> {{divisao.negocio.negocio_numero}} &nbsp;&nbsp;&nbsp; <b>Versão:</b> {{divisao.negocio.negocio_versao}} &nbsp;&nbsp;&nbsp; <b>Revisão:</b> {{divisao.negocio.negocio_revisao}}</td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Divisão:</strong> {{divisao.negocio.negocio_divisao}} - {{divisao.negocio.negocio_divisao_nome}}</td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Atividade:</strong> {{divisao.negocio.negocio_atividade}} - {{divisao.negocio.negocio_atividade_nome}}</td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Sequência:</strong> {{divisao.negocio.negocio_sequencia}} - {{divisao.negocio.titulo}}</td>
            <td></td>
          </tr>
        </table>
      </div>
    </el-row>

    <el-row type="flex" justify="left" :gutter="10" style="width: 100%;">
      <div v-if="carregandoNegocio" class="text-center">
        <p><i class="el-icon-loading"></i> Carregando Atividade da Divisão do Orçamento do Negócio...</p>
      </div>
      <div v-else-if="!divisao.negocio">
        <p><i class="el-icon-warning"></i> Nenhuma Atividade da Divisão do Orçamento do Negócio encontrado.</p>
      </div>
      <div v-else>
        <table>
          <tr>
            <td colspan="5"><h2>Detalhes da Atividade da Divisão:</h2></td>
          </tr>
          <tr>
            <td colspan="5"><h3>Detalhes da Formação de Preço</h3></td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
            <td class = "outros" style="width: 150px !important;">Percentual</td>
            <td class = "outros" style="width: 150px !important;">Total</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total de Matéria Prima:</strong></td>
            <!-- <td class="alinha-direita">R$ {{formatarValor(divisao.negocio.total_mp, 2)}}</td> -->
            <td class = "outros"><input class = "outros" style = "background-color:yellow;" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.total_mp"/></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total de Mão de Obra 1:</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.negocio.total_mo, 2)}}</td>
            <!-- <td class = "outros"><input class = "outros" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.total_mo"/></td> -->
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Total de Mão de Obra 2:</strong></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.negocio.perc_mo_2"/>%</td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.negocio.total_mo_2, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total do Frete:</strong></td>
            <td class = "outros"><input class = "outros" style = "background-color:red;" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.valor_frete" disabled/></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total de Despesas:</strong></td>
            <td class = "outros"><input class = "outros" style = "background-color:red;" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.valor_despesas" disabled/></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total de Outros:</strong></td>
            <td class = "outros"><input class = "outros" type="text" placeholder="R$ 0,00" v-model="divisao.negocio.valor_outros"/></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total do CMV:</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(cmv, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total do Markup 1:</strong></td>
            <td class="alinha-direita"><strong style="color: red;">R$ {{formatarValor(cmv, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total do Markup 2:</strong></td>
            <td class="alinha-direita"><strong style="color: red;">R$ {{formatarValor(cmv, 2)}}</strong></td>
          </tr>
          <tr>
            <td colspan="5"></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total da NBRtec:</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_nbrtec, 2)}}</strong></td>
          </tr>
          <tr>
            <td colspan="5"></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Total do Faturamento do Direto:</strong></td>
            <td class = "outros"><input class = "outros" style = "background-color:yellow;" type="text" placeholder="R$ 0.00" v-model="divisao.negocio.valor_faturamento_direto"/></td>
            <td class = "outros"><strong>R$ {{formatarValor(divisao.negocio.total_faturamento_direto, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total da Atividade da Divisão:</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_geral, 2)}}</strong></td>
          </tr>
          <tr>
            <td colspan="5"><br /></td>
          </tr>
          <tr class="destaque" style="color: red;">
            <td colspan="3"><strong>Total da Revisão:</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_geral, 2)}}</strong></td>
          </tr>
<!-- 
          <tr>
            <td colspan="5">
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoPrincipalAlterar()"> Alterar Dados da Atividade da Divisão do Negócio
              </el-button>
            </td>
          </tr>
 -->
          <tr>
            <td colspan="5"><br /></td>
          </tr>
          <tr>
            <td colspan="5"><h3>Detalhes dos Custos (Markup)</h3></td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
            <td class = "alinha-direita">Percentual</td>
            <td class = "alinha-direita">Total</td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Despesas Administrativas:</strong></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.markup.despesas_administrativas_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.despesas_administrativas_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Custo Indireto:</strong></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.markup.custo_indireto_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.custo_indireto_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Gastos Gerais Fabricação:</strong></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.markup.gastos_gerais_fabricacao_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.gastos_gerais_fabricacao_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Margem Faturamento Direto:</strong></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.markup.margem_faturamento_direto"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.faturamento_direto_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total:</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.markup.markup_total, 2)}}</strong></td>
          </tr>
<!-- 
          <tr>
            <td colspan="5">
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="alterarMarkupDivisaoNegocio()"> Alterar Dados do Markup da Atividade da Divisão do Negócio
              </el-button>
            </td>
          </tr>
 -->
          <tr>
            <td colspan="5"><br /></td>
          </tr>
          <tr>
            <td colspan="5"><h3>Detalhes do Lucro</h3></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td class = "alinha-direita">Fator</td>
            <td class = "alinha-direita">Percentual</td>
            <td class = "alinha-direita">Total</td>
          </tr>
          <tr class="destaque">
            <td><strong>Lucro 1:</strong></td>
            <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.margem.lucro_fator"/></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.margem.lucro_percentual"/>%</td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.margem.lucro_valor_1, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Lucro 2:</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.margem.lucro_valor_2, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>CSLL:</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.margem.csll_valor, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>IRPJ:</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.margem.irpj_valor, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Lucro Líquido:</strong></td>
            <td class="alinha-direita"><span style = "color:red;">{{formatarValor(divisao.margem.lucro_liquido_percentual, 2)}}%</span></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.margem.lucro_liquido_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Desconto Representante:</strong></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.margem.desconto_representante_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.margem.desconto_representante_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>Desconto Administrador:</strong></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.margem.desconto_administrador_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.margem.desconto_administrador_valor, 2)}}</strong></td>
          </tr>
          <tr>
            <td colspan="5"><br /></td>
          </tr>
          <tr>
            <td colspan="5"><h3>Detalhes das Comissões</h3></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td class = "alinha-direita">Fator</td>
            <td class = "alinha-direita">Percentual</td>
            <td class = "alinha-direita">Total</td>
            <td class = "alinha-direita">Encargos</td>
          </tr>
          <tr class="destaque">
            <td><strong>Comissão Gerente:</strong></td>
            <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.comissao.fator_comissao_gerente"/></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.comissao.comissao_gerente_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_gerente_valor, 2)}}</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.comissao.comissao_gerente_encargos_valor, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td><strong>Comissão Interna:</strong></td>
            <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.comissao.fator_comissao_interna"/></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.comissao.comissao_interna_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_interna_valor, 2)}}</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.comissao.comissao_interna_encargos_valor, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td><strong>Comissão Externa:</strong></td>
            <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.comissao.fator_comissao_externa"/></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.comissao.comissao_externa_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_externa_valor, 2)}}</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.comissao.comissao_externa_encargos_valor, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td><strong>Indicador Externo:</strong></td>
            <td class = "outros"><input class = "fator" type="text" placeholder="0,0000" v-model="divisao.comissao.fator_indicador_externo"/></td>
            <td class = "outros"><input class = "percentual" type="text" placeholder="0,00%" v-model="divisao.comissao.indicador_externo_percentual"/>%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.indicador_externo_valor, 2)}}</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(divisao.comissao.indicador_externo_encargos_valor, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total:</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_total, 2)}}</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.comissao.comissao_encargos_total, 2)}}</strong></td>
          </tr>
          <tr>
            <td colspan="5"><br /></td>
          </tr>
          <tr>
            <td colspan="5"><h3>Detalhes dos Tributos</h3></td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
            <td class = "outros" style="width: 150px !important;">Percentual</td>
            <td class = "outros" style="width: 150px !important;">Total</td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>ICMS:</strong></td>
            <td class="alinha-direita">{{formatarValor(divisao.imposto.icms_percentual, 2)}}%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.icms_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>PIS:</strong></td>
            <td class="alinha-direita">{{formatarValor(divisao.imposto.pis_percentual, 2)}}%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.pis_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>COFINS:</strong></td>
            <td class="alinha-direita">{{formatarValor(divisao.imposto.cofins_percentual, 2)}}%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.cofins_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>IPI:</strong> <span style="display: inline-block; width: 80%; text-align: right;">NCM {{divisao.imposto.ncm_numero}}</span></td>
            <td class="alinha-direita">{{formatarValor(divisao.imposto.ipi_percentual, 2)}}%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.ipi_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>IBS:</strong></td>
            <td class="alinha-direita">{{formatarValor(divisao.imposto.ibs_percentual, 2)}}%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.ibs_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>CBS:</strong></td>
            <td class="alinha-direita">{{formatarValor(divisao.imposto.cbs_percentual, 2)}}%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.cbs_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>CSLL:</strong></td>
            <td class="alinha-direita">{{formatarValor(divisao.imposto.csll_percentual, 2)}}%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.csll_valor, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="2"><strong>IRRF:</strong></td>
            <td class="alinha-direita">{{formatarValor(divisao.imposto.irpj_percentual, 2)}}%</td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.imposto.irpj_valor, 2)}}</strong></td>
          </tr>
<!-- 
          <tr>
            <td colspan="5">
              <el-button 
                class="details-icon-button"
                size="small"
                icon="el-icon-refresh"
                type="warning"
                :loading="loading"
                v-if="permissao.editar_painel"
                @click="alterarImpostoDivisaoNegocio()"
              >
                Alterar Dados do Imposto da Atividade da Divisão do Negócio
              </el-button>
            </td>
          </tr>
 -->
<!-- 
          <tr>
            <td colspan="5">
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="alterarComissaoDivisaoNegocio()"> Alterar Dados da Comissão da Atividade da Divisão do Negócio
              </el-button>
            </td>
          </tr>
 -->
<!-- 
          <tr>
            <td colspan="5">
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="alterarMargemDivisaoNegocio()"> Alterar Dados da Margem da Atividade da Divisão do Negócio
              </el-button>
            </td>
          </tr>
 -->
          <tr>
            <td colspan="5"><br /></td>
          </tr>
          <tr>
            <td colspan="5"><h3>Detalhes Totais</h3></td>
          </tr>
          <tr>
            <td colspan="3">&nbsp;</td>
            <td class = "outros" style="width: 150px !important;">Total</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total da NBRtec:</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_nbrtec, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total do Faturamento do Direto:</strong></td>
            <td class = "outros"><strong>R$ {{formatarValor(divisao.negocio.total_faturamento_direto, 2)}}</strong></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>Total da Atividade da Divisão:</strong></td>
            <td class="alinha-direita"><strong>R$ {{formatarValor(divisao.negocio.valor_total_geral, 2)}}</strong></td>
          </tr>
          <tr>
            <td colspan="5"><br/></td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>IBS:</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(ibs, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>CBS:</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(cbs, 2)}}</td>
          </tr>
          <tr class="destaque">
            <td colspan="3"><strong>IPI:</strong></td>
            <td class="alinha-direita">R$ {{formatarValor(ipi, 2)}}</td>
          </tr>
          <tr>
            <td colspan="5"><br /></td>
          </tr>
          <tr class="destaque">
            <td colspan="5"><h3>Observação Interna (Não Aparece na Proposta)</h3></td>
          </tr>
          <tr>
            <td colspan="5">
              <textarea 
                rows="8" 
                cols="80" 
                placeholder="Digite aqui suas observações internas..."
                v-model="divisao.negocio.observacao_interna"
              >
              </textarea>
            </td>
          </tr>
<!-- 
          <tr>
            <td colspan="5">
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="negocioRevisaoDivisaoPrincipalAlterar()"> Alterar Dados da Observação da Atividade da Divisão do Negócio
              </el-button>
            </td>
          </tr>
 -->
          <tr>
            <td colspan="5">
              <el-button
                class="details-icon-button"
                size="small"
                type="warning"
                icon="el-icon-refresh"
                v-if="permissao.editar_painel"
                @click="alterarDivisaoNegocio()"> Alterar os Dados da Atividade da Divisão do Negócio
              </el-button>
            </td>
          </tr>
        </table>
      </div>
    </el-row>
</div>
</template>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      tableKey: 0,
      loading: false,
      divisao: {
        "negocio":{},
        "cliente":{},
        "imposto":null,
        "mao_obra":null,
        "mao_obra_total":null,
        "comissao":null,
        "markup":null,
        "margem":null,
        "itens":[],
      },
      agrupamento: {
        "itens":[]
      },
      itensOriginais: [],
      // cmv: 0,
      ibs: 0,
      cbs: 0,
      ipi: 0,
      permissao: {},
      emailDestino: 'adriano.schneider@nbrtec.com.br',
      itensSelecionados: [],
      activeTab: 'principal',
      search: '',
      selectedRow: {},
      carregandoNegocio: false,
      carregandoDetalhe: false,
      carregandoMaoObra: false,
      carregandoImposto: false,
      carregandoComissao: false,
      carregandoMarkup: false,
      carregandoMargem: false,
      filtro: {
        tipo: '',    // 'fabricante' ou 'grupo'
        valor: ''    // código selecionado
      },
      opcoesFiltro: [],       // opções carregadas do servidor
      carregandoOpcoes: false,
      dadosTabelaOriginal: [], // backup dos dados completos
      //dadosTabelaFiltrados: [], // dados exibidos na tabela      

    };
  },
  watch: {
    search() {
      this.tableKey++  // Força remontar a tabela com os dados filtrados
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },

      dadosTabela() {
      if (!this.divisao.itens) return [];
      if (!this.search) return this.divisao.itens;
      return this.filtrarArvore(this.divisao.itens, this.search.toLowerCase());
    },

    // Se você já tem dadosTabela, use isso para evitar duplicar
    dadosTabelaFiltrados() {
      // Se não houver filtro ativo, retorna todos
      
      if (!this.filtro.tipo || !this.filtro.valor) {
        return this.dadosTabelaOriginal;
      }

      // Filtra recursivamente na árvore
      const filtrarArvore = (itens) => {
        return itens
          .map(item => {
            let novoItem = { ...item };
            if (novoItem.filhos && novoItem.filhos.length > 0) {
              novoItem.filhos = filtrarArvore(novoItem.filhos);
            }

            // Verifica se o item tem o código do fabricante/grupo
            const campo = this.filtro.tipo === 'fabricante' ? 'cod_fabricante' : 'cod_grupo';
            if (novoItem[campo] === this.filtro.valor) {
              return novoItem;
            }

            // Mantém o pai se tiver filhos que atendem ao filtro
            if (novoItem.filhos && novoItem.filhos.length > 0) {
              return novoItem;
            }

            return null;
          })
          .filter(item => item !== null);
      };

      return filtrarArvore(this.dadosTabelaOriginal);
    },

    cmv() {
    if (!this.divisao?.negocio) return 0;
    return (
      Number(this.divisao.negocio.total_mp || 0) +
      Number(this.divisao.negocio.total_mo || 0) +
      Number(this.divisao.negocio.total_mo_2 || 0) +
      // Number(this.divisao.negocio.valor_frete || 0) +
      // Number(this.divisao.negocio.valor_despesas || 0) +
      Number(this.divisao.negocio.valor_outros || 0)
    );
  }

  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.gerencial_painel) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    //this.negocioRevisaoDivisaoGeralCarregar();
    //this.aplicarFormatoFinal({ target: this.$el.querySelector('input') });
    this.negocioRevisaoDivisaoRecalcular()
  },
  methods: {
    async negocioRevisaoDivisaoGeralCarregar() {

      // console.log("Carregar divisão de negócio geral");
      // this.divisao.geral = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.negocio = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/geral/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          console.log("Divisão do Negócio Geral:", response.data);

          this.divisao.negocio = response.data.negocio;
          this.divisao.cliente = response.data.cliente;
          this.divisao.mao_obra = response.data.mao_obra;
          this.divisao.mao_obra_total = response.data.mao_obra_total;

          // this.cmv = this.divisao.negocio.total_mp + 
          //            this.divisao.negocio.total_mo + 
          //            this.divisao.negocio.total_mo_2 + 
          //            this.divisao.negocio.valor_frete + 
          //            this.divisao.negocio.valor_despesas + 
          //            this.divisao.negocio.valor_outros;
          this.ibs = this.divisao.negocio.valor_total_nbrtec * (this.divisao.negocio.ibs / 100);
          this.cbs = this.divisao.negocio.valor_total_nbrtec * (this.divisao.negocio.cbs / 100);
          this.ipi = this.divisao.negocio.valor_total_nbrtec * (this.divisao.negocio.ipi / 100);
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados Gerais da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #01: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }

    },

    async negocioRevisaoDivisaoMaoObraCarregar() {
      // implementar requisição com o JSON da Mão de Obra

      // console.log("Carregar Mão de Obra da divisão de negócio");
      // this.divisao.negocio = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.mao_obra = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/mao_obra/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Mão de Obra:", response.data);
          this.divisao.mao_obra = response.data.mao_obra;
          this.divisao.mao_obra_total = response.data.mao_obra_total;
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados da Mão de Obra da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #03: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }

    },

    async negocioRevisaoDivisaoImpostoCarregar() {
      // implementar requisição com o JSON dos impostos
      
      // console.log("Carregar detalhes da divisão de negócio");
      // this.divisao.imposto = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.imposto = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/imposto/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Impostos:", response.data);
          this.divisao.imposto = response.data.imposto;
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados dos Impostos da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #04: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoComissaoCarregar() {
      // implementar requisição com o JSON das comissões
      
      // console.log("Carregar comissoes da divisão de negócio");
      // this.divisao.comissao = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.comissao = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/comissao/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Comissões:", response.data);
          this.divisao.comissao = response.data.comissao;
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados das Comissões da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #05: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoMarkupCarregar() {
      // implementar requisição com o JSON dos markup
      
      // console.log("Carregar markup da divisão de negócio");
      // this.divisao.markup = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.markup = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/markup/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Markups:", response.data);
          this.divisao.markup = response.data.markup;
          // console.log('Divisão do Negócio carregada:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados do Markup da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #06: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoMargemCarregar() {
      // implementar requisição com o JSON das margens
      
      // console.log("Carregar margens da divisão de negócio");
      // this.divisao.margem = {"x":1, "y":2};

      if (this.$route.params.id) {

        this.loading = true;
        this.divisao.margem = {};
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          const response = await axios.get(url + "/negocio/revisao/divisao/margem/carregar/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Margens:", response.data);
          this.divisao.margem = response.data.margem;
          // console.log('Divisão do Negócio carregada #61:', this.divisao);

          this.$notify({
            title: "Sucesso",
            message: "Dados da Margem da Atividade da Divisão do Negócio recuperados com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #06: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }
    },

    async negocioRevisaoDivisaoRecalcular() {
      // implementar requisição para recalcular a divisão do negócio

      // console.log("Recalcular divisão de negócio");

      if (this.$route.params.id) {

        this.loading = true;
        const id = this.$route.params.id;

        try {

          if (!id || isNaN(id)) {
            this.$notify.warning({ title: 'Atenção', message: 'Código da Divisao do Negócio vazio.' });
            return;
          }

          // console.log("Enviando requisição para recalcular divisão do negócio com ID:", id);
          const response = await axios.get(url + "/negocio/revisao/divisao/recalcular/" + id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            }
          });

          // console.log("Resposta recebida do servidor:", response);

          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }

          if (response.status === 401) {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            return;
          }

          // console.log("Divisão do Negócio Recalculada:", response.data);

          this.negocioRevisaoDivisaoGeralCarregar();
          this.negocioRevisaoDivisaoMaoObraCarregar();
          this.negocioRevisaoDivisaoImpostoCarregar();
          this.negocioRevisaoDivisaoComissaoCarregar();
          this.negocioRevisaoDivisaoMarkupCarregar();
          this.negocioRevisaoDivisaoMargemCarregar();
          // console.log('DIVISAO #57: ', this.divisao);
          this.$notify({
            title: "Sucesso",
            message: "Recalculo da Atividade da Divisão do Negócio realizado com sucesso!",
            type: "success",
          });

        } catch (error) {
          this.$notify({
            title: "Erro",
            message: `Falha ao realizar a pesquisa #07: ${error.message}`,
            type: "error",
          });
        } finally {
          this.loading = false;
        }

      }

    },

    formatarData(date) {
      return date.toISOString().split('T')[0]; // '2025-11-07' 'YYYY-MM-DD'
    },

    // Função de filtro recursivo
    filtrarArvore(nodes, query) {
      if (!nodes) return [];

      return nodes.reduce((acc, node) => {
          const nodeDescription = (node.descricao || '').toLowerCase();
          let matches = nodeDescription.includes(query);

          // Filtra recursivamente os filhos
          const filhosFiltrados = this.filtrarArvore(node.filhos, query);

          if (filhosFiltrados.length > 0) {
          matches = true; // Se um filho corresponde, o pai também deve ser exibido
          }

          if (matches) {
          // Clona o nó para não alterar os dados originais
          const newNode = { ...node };
          // Atribui os filhos já filtrados ao novo nó
          newNode.filhos = filhosFiltrados;
          acc.push(newNode);
          }

          return acc;
      }, []);
    },

    formatarValor(valor, casas = 2) {

      if (!valor && valor !== 0) {
        return '';
      }
      // Converte para número para garantir que a formatação funcione
      const valorNumerico = Number(valor);

      // Verifica se é um número válido
      if (isNaN(valorNumerico)) {
        return valor;
      }

      // Usa Intl.NumberFormat para o padrão brasileiro (ponto no milhar, vírgula para decimal)
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
      }).format(valorNumerico);
    },

    async alterarDivisaoNegocio() {

      // console.log('##3289892', this.divisao)
      // ###################
      await this.negocioRevisaoDivisaoPrincipalAlterar();
      await this.negocioRevisaoDivisaoMaoObraAlterar();
      // await this.negocioRevisaoDivisaoImpostoAlterar();
      await this.negocioRevisaoDivisaoComissaoAlterar();
      await this.negocioRevisaoDivisaoMarkupAlterar();
      await this.negocioRevisaoDivisaoMargemAlterar();
      await this.negocioRevisaoDivisaoRecalcular();

    },

    async negocioRevisaoDivisaoPrincipalAlterar(){

      // Validação básica
      if (!this.divisao.negocio) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'Dados do negócio não carregados.',
        });
        return;
      }

      // Validação Valor Total da Materia Prima
      if (this.divisao.negocio.total_mp < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Total da Matéria Prima deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Total da Mão de Obra
      if (this.divisao.negocio.total_mo < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Total da Mão de Obra deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Total da Mão de Obra
      if (this.divisao.negocio.perc_mo_2 < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Percentual da Mão de Obra 2 deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Total da Mão de Obra
      if (this.divisao.negocio.total_mo_2 < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Total da Mão de Obra 2 deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Frete
      if (this.divisao.negocio.valor_frete < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Frete deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor das Despesas
      if (this.divisao.negocio.valor_despesas < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor das Despesas deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Valor Outros
      if (this.divisao.negocio.valor_outros < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor outros deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Faturamento Direto
      if (this.divisao.negocio.valor_faturamento_direto < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo Valor Faturamento Direto deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      try {

        this.loading = true;

        const dados = {
          negocio_id: this.divisao.negocio.id,
          total_mp: this.divisao.negocio.total_mp,
          total_mo: this.divisao.negocio.total_mo,
          perc_mo_2: this.divisao.negocio.perc_mo_2,
          total_mo_2: this.divisao.negocio.total_mo_2,
          valor_frete: this.divisao.negocio.valor_frete,
          valor_despesas: this.divisao.negocio.valor_despesas,
          valor_outros: this.divisao.negocio.valor_outros,
          valor_faturamento_direto: this.divisao.negocio.valor_faturamento_direto,
          observacao_interna: this.divisao.negocio.observacao_interna,
          
        };

        // console.log("Dados a serem alterados:", dados);      

        // console.log("Foi!");

        const response = await axios.post(url + "/negocio/revisao/divisao/principal/alterar/",dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.$notify({
          title: "Sucesso",
          message: "Principal da Atividade da Divisão do Negócio ajustados com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar o principal.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    async negocioRevisaoDivisaoMaoObraAlterar(){

      try {

        this.loading = true;

        const payload = {
          negocio_divisao_id: this.divisao.negocio.id,
          mao_obra: this.divisao.mao_obra.map(item => ({
            id: parseInt(item.codigo),
            qtde_hora: Number(item.qtde_hora),
            valor_hora: Number(item.valor_hora)
          }))
        };

        // console.log("Dados a serem alterados:", payload);      

        const response = await axios.post(url + "/negocio/revisao/divisao/mao-obra/alterar/",payload, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log('Sucesso!', response.data);

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.$notify({
          title: "Sucesso",
          message: "Mão de Obra da Atividade da Divisão do Negócio ajustada com sucesso!",
          type: "success",
        });

      } catch (error) {
        console.error('Erro ao enviar dados:', error);
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar a mão de obra.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }

     },

    async negocioRevisaoDivisaoImpostoAlterar(){

      // // Validação básica
      // if (!this.divisao.imposto) {
      //   this.$notify.warning({
      //     title: 'Atenção',
      //     message: 'Dados de imposto não carregados.',
      //   });
      //   return;
      // }

      // // Validação do NCM (obrigatório)
      // const ncm = this.divisao.imposto.ncm_numero?.toString().trim();
      // if (!ncm) {
      //   this.$notify.warning({
      //     title: 'Atenção',
      //     message: 'O campo NCM é obrigatório.',
      //   });
      //   return;
      // }

      // try {

      //   this.loading = true;

      //   const dados = {
      //     negocio_id: this.divisao.negocio.id,
      //     ncm_numero: ncm,
      //   };

      //   // console.log("Dados a serem alterados:", dados);      

      //   // console.log("Foi!");

      //   const response = await axios.post(url + "/negocio/revisao/divisao/imposto/alterar/",dados, {
      //     headers: {
      //       Authorization: "Bearer " + this.$store.state.token,
      //     }
      //   });

      //   // console.log("Voltou (1)!");

      //   if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
      //     this.$store.dispatch("logout").then(() => {
      //       this.$router.push("/login");
      //     });
      //   }

      //   if (response.status === 401) {
      //     await this.$store.dispatch("logout");
      //     this.$router.push("/login");
      //     return;
      //   }

      //   // console.log("Resposta: ", response.data);
      //   // console.log("Voltou (2)!");

      //   this.$notify({
      //     title: "Sucesso",
      //     message: "Impostos da Atividade da Divisão do Negócio ajustados com sucesso!",
      //     type: "success",
      //   });

      // } catch (error) {
      //   this.$notify({
      //     title: "Erro",
      //     message: error.response?.data?.message || "Falha ao salvar os impostos.",
      //     type: "error",
      //   });
      // } finally {
      //   this.loading = false;
      // }

    },

    async negocioRevisaoDivisaoComissaoAlterar(){

      // Validação básica
      if (!this.divisao.comissao) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'Dados das Comissões do negócio não foram carregados.',
        });
        return;
      }

      // Validação Percentual Comissão Gerente
      if (this.divisao.comissao.comissao_gerente_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Comissão do Gerente deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Comissão Interna
      if (this.divisao.comissao.comissao_interna_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Comissão Interna deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Comissão Externa
      if (this.divisao.comissao.comissao_externa_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Comissão Externa deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Indicador Externo
      if (this.divisao.comissao.indicador_externo_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual do Indicador Externo deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Fator Comissão Gerente
      if (this.divisao.comissao.fator_comissao_gerente < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator de Comissão do Gerente deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Fator Comissão Interna
      if (this.divisao.comissao.fator_comissao_interna < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator de Comissão Interna deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Fator Comissão Externa
      if (this.divisao.comissao.fator_comissao_externa < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator de Comissão Externa deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Fator Indicador Externo
      if (this.divisao.comissao.fator_indicador_externo < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator do Indicador Externo deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      try {

        this.loading = true;

        const dados = {
          negocio_id: this.divisao.negocio.id,
          fabricante_id: this.divisao.cliente.cliente_cod,
          comissao_gerente_percentual: Number(this.divisao.comissao.comissao_gerente_percentual),
          comissao_interna_percentual: Number(this.divisao.comissao.comissao_interna_percentual),
          comissao_externa_percentual: Number(this.divisao.comissao.comissao_externa_percentual),
          indicador_externo_percentual: Number(this.divisao.comissao.indicador_externo_percentual),
          fator_comissao_gerente: Number(this.divisao.comissao.fator_comissao_gerente),
          fator_comissao_interna: Number(this.divisao.comissao.fator_comissao_interna),
          fator_comissao_externa: Number(this.divisao.comissao.fator_comissao_externa),
          fator_indicador_externo: Number(this.divisao.comissao.fator_indicador_externo),
        };

        // console.log("Dados a serem alterados:", dados);      

        // console.log("Foi!");

        const response = await axios.post(url + "/negocio/revisao/divisao/comissao/alterar/",dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.$notify({
          title: "Sucesso",
          message: "Comissões da Atividade da Divisão do Negócio ajustados com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar as comissões.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    async negocioRevisaoDivisaoMarkupAlterar(){

      // Validação básica
      if (!this.divisao.markup) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'Dados de Markup do negócio não foram carregados.',
        });
        return;
      }

      // Validação Percentual Markup Despesas Administrativas
      if (this.divisao.markup.despesas_administrativas_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Markup das Despesas Administrativas deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Markup Custo Indireto
      if (this.divisao.markup.custo_indireto_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Markup de Custo Indireto deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Markup Gastos Gerais Fabricação
      if (this.divisao.markup.gastos_gerais_fabricacao_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Markup de Gastos Gerais de Fabricação deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      // Validação Percentual Markup Gastos Gerais Fabricação
      if (this.divisao.markup.margem_faturamento_direto < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual de Markup da Margem do Faturamento Direto deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      try {

        this.loading = true;

        const dados = {
          negocio_id: this.divisao.negocio.id,
          despesas_administrativas_percentual: Number(this.divisao.markup.despesas_administrativas_percentual),
          custo_indireto_percentual: Number(this.divisao.markup.custo_indireto_percentual),
          gastos_gerais_fabricacao_percentual: Number(this.divisao.markup.gastos_gerais_fabricacao_percentual),
          margem_faturamento_direto: Number(this.divisao.markup.margem_faturamento_direto),
        };

        // console.log("Dados a serem alterados #33:", dados);      

        // console.log("Foi!");

        const response = await axios.post(url + "/negocio/revisao/divisao/markup/alterar/",dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.negocioRevisaoDivisaoRecalcular();

        this.$notify({
          title: "Sucesso",
          message: "Markup da Atividade da Divisão do Negócio ajustados com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar os Markups.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    async negocioRevisaoDivisaoMargemAlterar() {

      // Validação básica
      if (!this.divisao.margem) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'Dados da Margens do negócio não foram carregados.',
        });
        return;
      }

      // Validação Percentual Markup Despesas Administrativas
      if (this.divisao.margem.lucro_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual da Margem de Lucro deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }
      if (this.divisao.margem.lucro_fator < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do fator da Margem de Lucro deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }
      if (this.divisao.margem.desconto_representante_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual do Desconto do Representante_percentual deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }
      if (this.divisao.margem.desconto_administrador_percentual < 0) {
        this.$notify.warning({
          title: 'Atenção',
          message: 'O campo do percentual do Desconto do Administrador deve ser preenchido com um valor zerado ou maior.',
        });
        return;
      }

      try {

        this.loading = true;

        const dados = {
          negocio_id: this.divisao.negocio.id,
          negocio_revisao_id: this.divisao.margem.negocio_revisao_id,
          fabricante_id: this.divisao.cliente.cliente_cod,
          lucro_percentual: Number(this.divisao.margem.lucro_percentual),
          lucro_fator: Number(this.divisao.margem.lucro_fator),
          desconto_representante_percentual: Number(this.divisao.margem.desconto_representante_percentual),
          desconto_administrador_percentual: Number(this.divisao.margem.desconto_administrador_percentual),
        };

        // console.log("Dados a serem alterados #87:", dados);      

        // console.log("Foi!");

        const response = await axios.post(url + "/negocio/revisao/divisao/margem/alterar/",dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });

        // console.log("Voltou (1)!");

        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }

        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // console.log("Voltou (2)!");

        this.$notify({
          title: "Sucesso",
          message: "Margens da Atividade da Divisão do Negócio ajustados com sucesso!",
          type: "success",
        });

      } catch (error) {
        this.$notify({
          title: "Erro",
          message: error.response?.data?.message || "Falha ao salvar as Margens.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

  },
};
</script>
<style scoped>

  .el-table {
    box-sizing: border-box;
  }
  .el-table th,
  .el-table td {
    display: table-cell !important;
    text-align: left;
    padding: 10px;
  }
  .el-table__header,
  .el-table__body {
    width: 100%;
    table-layout: fixed;
  }
  .el-table .el-table__cell {
    padding: 0;
  }
  .details-icon-button.el-button--mini {
    padding: 5px;
  }
  .item {
    margin:0;
  }
  .main-table .el-table__body-wrapper /deep/.el-table__row /deep/.el-table__cell {
    background-color: #f0f9eb !important;
  }
  .second-table .el-table__body-wrapper /deep/.el-table__row /deep/.el-table__cell {
    background-color: white !important;
  }

  .el-row-topo {
    margin-top: 10px;
  }

  .el-table .root-row {
    font-weight: bold;
    background-color: #f0f9eb; /* Um fundo verde claro para destacar mais */
  }

  /* Adiciona um ícone de "documento" antes do texto na primeira coluna
    apenas para as linhas que são "folhas" (classe 'is-leaf').
    Isso alinha visualmente o conteúdo de todas as linhas.
  */  
  .el-table .is-leaf .tree-column-codigo .cell::before {
      content: "\e722"; /* Código para o 'el-icon-document' */
      font-family: 'element-icons';
      color: #c0c4cc;
      font-size: 12px;
      
      /* Espaçamento para simular o ícone de expandir/recolher */
      display: inline-block;
      width: 24px;
      text-align: center;
      vertical-align: middle;
  }

  /* Estilo para a div que contém os botões e o filtro */
  .table-controls {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  /* Estilo para o campo de filtro */
  .filter-input {
    width: 400px;
    margin-right: 10px;
  }

  /* Novo estilo para deixar o botão de detalhes menor */
  .details-icon-button.el-button--mini {
    padding: 5px; /* Reduz o preenchimento ao redor do ícone */
  }

  /* Estilos para o conteúdo da janela de detalhes */
  .details-content p {
    margin: 10px 0;
    font-size: 16px;
    line-height:0.8
  }

  .details-content p strong {
    display: inline-block;
    width: 120px;     
  }

  .el-table .el-table__cell {
    padding: 0;
  }
  .alinha-direita {
    text-align: right !important;
    padding-left: 20px !important;
  }
  .qtde-horas {
    width: 60px !important;
    text-align: right !important;
  }
  .valor-hora {
    width: 60px !important;
    text-align: right !important;
  }
  .outros {
    width: 115px !important;
    text-align: right !important;
  }
  .fator {
    width: 50px !important;
    text-align: right !important;
  }
  .percentual {
    width: 50px !important;
    text-align: right !important;
  }
  tr.destaque:hover,
  tr.destaque:focus {
      background-color: rgb(236, 236, 236) !important;
  }
</style>
